import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const CourseViewerRedirect: React.FC = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (courseId) {
      // Redirect to the new curriculum page
      navigate(`/course/${courseId}/curriculum`, { replace: true });
    }
  }, [courseId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>
  );
};

export default CourseViewerRedirect;
